module.exports = __webpack_public_path__ + "static/media/Nguyen_Anh_Duc.f865e093.PNG";